import { render } from "./ArrowDown.vue?vue&type=template&id=15eae308&ts=true"
import script from "./ArrowDown.vue?vue&type=script&lang=ts"
export * from "./ArrowDown.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__